import { defaultLocale, resolveLocale } from './Locale';
/**
 * Used to load string table for localization. If failed to get string table for the given locale, it
 * will try to get string table for default locale
 *
 * @param getStringTable String table fetcher callback which returns a string table of type T.
 * @param locale Locale of strings to fetch.
 */ export function getStringTableWithFallback(getStringTable, locale) {
    // We need to download the strings for the right language before rendering them to the user.
    return new Promise((resolve, reject)=>{
        getStringTable(resolveLocale(locale)).then((table)=>{
            resolve(table);
        }).catch(()=>{
            // avoid retry if locale is default locale
            if (locale === defaultLocale) {
                // TODO: https://office.visualstudio.com/OC/_workitems/edit/5826124
                // eslint-disable-next-line prefer-promise-reject-errors
                reject(`Get string table failed.`);
                return;
            }
            // If locale is unsupported, then fetch strings for the default locale
            getStringTable(defaultLocale).then((table)=>{
                resolve(table);
            }).catch(()=>{
                // TODO: https://office.visualstudio.com/OC/_workitems/edit/5826124
                // eslint-disable-next-line prefer-promise-reject-errors
                reject(`Get string table fallback failed.`);
            });
        });
    });
}
